import { createSelector } from 'reselect';

const applicationsSelector = (state) => state.applications;

export const savingApplications = createSelector(
  [applicationsSelector],
  (applications) => applications.saving
);

export const selectApplications = createSelector(
  [applicationsSelector],
  (applications) => applications.applications
);

export const selectApplicationsLoading = createSelector(
  [applicationsSelector],
  (applications) => applications.loading
);

export const selectAddApplicationData = createSelector(
  [applicationsSelector],
  (applications) => applications.addingApplicationData
);

export const selectCourses = createSelector(
  [applicationsSelector],
  (applications) => applications.courses
);

export const selectApplicationFilterActive = createSelector(
  [applicationsSelector],
  (applications) => applications.filterOn
);

export const selectCurrentApplication = createSelector(
  [applicationsSelector],
  (applications) => applications.currentApplication
);

export const selectCurrentApplicationLoading = createSelector(
  [applicationsSelector],
  (applications) => applications.fetchingSingleApplication
);

// candidate groups
export const selectSearch = createSelector(
  [applicationsSelector],
  (applications) => applications.candidateGroup
);

export const selectSearchLoading = createSelector(
  [applicationsSelector],
  (applications) => applications.candidateGroupLoading
);

export const selectSingleGroup = createSelector(
  [applicationsSelector],
  (applications) => applications.selectedGroup
);

export const selectSelectedGroups = createSelector(
  [applicationsSelector],
  (applications) => applications.selectedGroups
);